export default function siteDetailsReducer
    (state = { error:null, success:null, processing:false }, action) {

    switch (action.type)
    {
        case 'GET_SITE_SUCCESS':
            return {...state, ...{success: action.success }};

        case 'GET_SITE_ERROR':
            return {...state, ...{ error: action.error }};

        case 'GET_SITE_PROCESSING':
            return {...state, ...{ processing: action.processing }};

        default: return state;
    }
}